// 分组类型字典
export const groupTypeDic = [
  { label: "防水", value: "WATERPROOF", color: "#409EFF" },
  { label: "回填", value: "BACKFILL", color: "#67C23A" },
  { label: "吊顶", value: "HANG_CEILING", color: "#E6A23C" },
];

/**
 * 价格字段元数据。前端按 type 动态渲染对应的价格分区。
 * 每个分区下的字段都是「可选启用」——用户按需添加，不需要的不会出现在表单中。
 */
export const priceSectionsMap = {
  WATERPROOF: [
    {
      key: "basePit",
      title: "基坑施工费",
      desc: "基坑施工面积/个数单价及误工费",
      icon: "el-icon-coin",
      fields: [
        { prop: "basePitAreaPrice", label: "基坑面积单价", suffix: "元/㎡", placeholder: "如 27" },
        { prop: "basePitCountPrice", label: "基坑个数单价", suffix: "元/个", placeholder: "如 100" },
        { prop: "basePitDelayFee", label: "基坑误工费", suffix: "元/勾选", placeholder: "如 100" },
      ],
    },
    {
      key: "surface",
      title: "面层施工费",
      desc: "面层施工面积单价及误工费",
      icon: "el-icon-files",
      fields: [
        { prop: "surfaceAreaPrice", label: "面层面积单价", suffix: "元/㎡", placeholder: "如 27" },
        { prop: "surfaceDelayFee", label: "面层误工费", suffix: "元/勾选", placeholder: "如 100" },
      ],
    },
    {
      key: "smallOrder",
      title: "小单补贴",
      desc: "小订单触发的人工费补贴策略",
      icon: "el-icon-medal",
      fields: [
        { prop: "smallOrderThresholdSqm", label: "小单阈值", suffix: "㎡", placeholder: "如 40" },
        { prop: "laborCostPerSqm", label: "人工费单价", suffix: "元/㎡", placeholder: "如 8" },
      ],
    },
    {
      key: "remote",
      title: "远程加价",
      desc: "超出公里数阈值的远程加价",
      icon: "el-icon-position",
      fields: [
        { prop: "remoteThresholdKm", label: "远程阈值", suffix: "km", placeholder: "如 30" },
        { prop: "remoteRatePerKm", label: "每公里单价", suffix: "元/km", placeholder: "如 0.6" },
      ],
    },
    {
      key: "minMaterial",
      title: "最低用料标准",
      desc: "防水阶段每平方最低用料标准",
      icon: "el-icon-s-claim",
      fields: [
        { prop: "waterproofMinMaterialPerSqm", label: "最低用料单价", suffix: "元/㎡", placeholder: "如 10" },
      ],
    },
  ],
  BACKFILL: [
    {
      key: "backfill",
      title: "回填施工费",
      desc: "回填面积、二排、模具及误工费",
      icon: "el-icon-coin",
      fields: [
        { prop: "backfillAreaPrice", label: "回填面积单价", suffix: "元/㎡", placeholder: "" },
        { prop: "backfillAreaMinSqm", label: "回填面积保底", suffix: "㎡", placeholder: "" },
        { prop: "backfillSecondRowPrice", label: "二排个数单价", suffix: "元/个", placeholder: "" },
        { prop: "backfillMoldPrice", label: "模具个数单价", suffix: "元/个", placeholder: "" },
        { prop: "backfillDelayFee", label: "回填误工费", suffix: "元/勾选", placeholder: "" },
      ],
    },
    {
      key: "stair",
      title: "步梯加价",
      desc: "高楼层步梯计费",
      icon: "el-icon-top",
      fields: [
        { prop: "stairFloorThreshold", label: "步梯起算楼层", suffix: "层", placeholder: "" },
        { prop: "stairFloorRate", label: "每层费用", suffix: "元/层", placeholder: "" },
      ],
    },
    {
      key: "remote",
      title: "远程加价",
      desc: "超出公里数阈值的远程加价",
      icon: "el-icon-position",
      fields: [
        { prop: "remoteThresholdKm", label: "远程阈值", suffix: "km", placeholder: "" },
        { prop: "remoteRatePerKm", label: "每公里单价", suffix: "元/km", placeholder: "" },
      ],
    },
    {
      key: "minMaterial",
      title: "最低用料标准",
      desc: "基坑回填阶段每平方最低用料标准",
      icon: "el-icon-s-claim",
      fields: [
        { prop: "backfillMinMaterialPerSqm", label: "最低用料单价", suffix: "元/㎡", placeholder: "如 10" },
      ],
    },
  ],
  HANG_CEILING: [],
};

// 所有可能涉及的价格字段（用于编辑回显时识别已配置项 / 删除时清空字段）
export const allPriceProps = Array.from(
  new Set(
    Object.values(priceSectionsMap)
      .flat()
      .flatMap((section) => section.fields.map((f) => f.prop))
  )
);

export const userTableOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: true,
  showHeader: true,
  index: true,
  indexLabel: "序号",
  selection: true,
  menu: true,
  menuWidth: 180,
  page: true,
  addBtn: false,
  editBtn: false, // 改为弹窗编辑
  menuType: "text",
  delBtn: false,
  viewBtn: false,
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "分组名称",
      prop: "groupName",
      placeholder: "请输入分组名称",
      search: true,
      type: "input",
    },
    {
      label: "分组类型",
      prop: "type",
      type: "select",
      search: true,
      dicData: groupTypeDic.map((i) => ({ label: i.label, value: i.value })),
      formatter: (row) => {
        const item = groupTypeDic.find((i) => i.value === row.type);
        return item ? item.label : row.type || "-";
      },
    },
    {
      label: "排序",
      prop: "sort",
      type: "input",
      width: 80,
    },
    {
      label: "价格配置",
      prop: "priceConfigSummary",
      width: 130,
      formatter: (row) => {
        const count = allPriceProps.filter(
          (k) => row[k] !== null && row[k] !== undefined && row[k] !== ""
        ).length;
        return count > 0 ? `已配置 ${count} 项` : "未配置";
      },
    },
  ],
};
